<template>
    <div :class="{'row': !isFloat}">
        <div v-if="!isFloat" class="col-sm-4 field-label">{{ label }}</div>
        <div class="form-group" :class="{ 'form-group--float': isFloat, 'col-sm-8': !isFloat, 'form-group--centered': isCentered }">
            <input :type="getInputType" class="form-control" :id="id" :name="name" :value="value"
                   :class="[{ 'form-control--active': isLabelFloatActive, 'is-invalid': errors.has(name)}, getSizeClass, getCustomClass]"
                   v-validate="getValidators" :data-vv-as="label"
                   @input="$emit('input', $event.target.value)">
            <label v-if="isFloat">{{ label }}</label>
            <i class="form-group__bar"></i>
            <div class="invalid-feedback">
                {{ errors.first(name) }}
            </div>
        </div>
    </div>
</template>

<script>
    import formElementMixin from '@/components/mixins/FormElementMixin'
    //import flatpickr from 'flatpickr'

    export default {
        mixins: [formElementMixin],

        props: {
            type: {default: 'text'}
        },

        computed: {
            getCustomClass() {
                if(this.type == 'date'){
                    return 'date-picker flatpickr-input'
                }
            },

            getInputType() {
                if(this.type == 'password'){
                    return this.type
                }

                return 'text'
            }
        },

        mounted() {
            /*if(this.type == 'date'){
                flatpickr('.date-picker', {
                    enableTime: true,
                })
            }*/
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form_elements/Base.vue